import { useState, useEffect } from 'react';

export const useMinValue = (initialValue: number, minValue: number, maxValue: number) => {
  const [realValue, setRealValue] = useState(initialValue);
  const [inputValue, setInputValue] = useState<number | string>(initialValue);

  useEffect(() => {
    const inputValueAsNumber = Number(inputValue);

    if (!isNumber(inputValueAsNumber)) return;

    if (isNaN(inputValueAsNumber)) {
      setInputValue(realValue);
      return;
    }

    if (inputValueAsNumber < minValue) {
      setRealValue(minValue);
      return;
    }

    if (inputValueAsNumber > maxValue) {
      setRealValue(maxValue);
      setInputValue(maxValue);
      return;
    }

    setRealValue(inputValueAsNumber);
  }, [inputValue]);

  return [realValue, inputValue, setInputValue] as const;
};

function isNumber(value: number) {
  return typeof value === 'number';
}
